export const GIFT_SEND_TYPE_SNS: string = "01";
export const GIFT_SEND_TYPE_SELECT: string = "02";
export const GIFT_SEND_TYPE_DX: string = "03";
export const GIFT_SEND_TYPE_URL: string = "04";
export const GIFT_SEND_TYPE_SEAL: string = "12";
export const GIFT_SEND_TYPE_BOX: string = "14";
export const GIFT_SEND_TYPE_CASE: string = "15";
export const GIFT_SEND_TYPE_OPEN: string = "16";
export const GIFT_SEND_TYPE_BOOK: string = "21";
export const GIFT_SEND_TYPE_PNG: string = "31";

export function isSealType(send_type:String):boolean{
    return GIFT_SEND_TYPE_SEAL === send_type;
}
export function isQrType(send_type:String):boolean{
    return GIFT_SEND_TYPE_PNG === send_type || GIFT_SEND_TYPE_SEAL === send_type;
}
export function isNoshiWrapType(send_type:String):boolean{
    return GIFT_SEND_TYPE_BOX === send_type || GIFT_SEND_TYPE_BOOK === send_type;
}